import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { QuestionnaireStatus } from '@common/enums';
import { validationOptions } from '@common/validation/evidencio/evidencio';

export interface IRespiAllerQuestionnaireStatusCustomControlData {
    status: QuestionnaireStatus;
}

type TypedRespiAllerQuestionnaireSchema = TypedSchema<IRespiAllerQuestionnaireStatusCustomControlData>;

const respiAllerQuestionnaireStatusBaseSchema: TypedRespiAllerQuestionnaireSchema = {
    status: Koi.koi().enum(QuestionnaireStatus).required(),
};

export const respiAllerQuestionnaireStatusSchema = Koi.object(respiAllerQuestionnaireStatusBaseSchema);

export function isQuestionnaireStatus(value: unknown): value is QuestionnaireStatus {
    return Object.values(QuestionnaireStatus).includes(value as QuestionnaireStatus);
}

export function isQuestionnaireStatusBody(value: unknown): value is SaveQuestionnaireStatusRequestBody {
    if (typeof value === 'object' && value) {
        if ('status' in value && typeof (value as SaveQuestionnaireStatusRequestBody).status === 'string') {
            return isQuestionnaireStatus((value as SaveQuestionnaireStatusRequestBody).status);
        }
    }

    return false;
}
export type SaveQuestionnaireStatusRequestBody = {
    status: QuestionnaireStatus;
};

export const saveQuestionnaireStatusRequestBodyValidation: TypedSchema<SaveQuestionnaireStatusRequestBody> = {
    status: Koi.koi().enum(QuestionnaireStatus).required(),
};

export const saveQuestionnaireStatusRequestBodySchema = Koi.object(
    saveQuestionnaireStatusRequestBodyValidation
).options(validationOptions);
